import React, { useEffect, useRef, useState } from 'react'
import CreateProductsStyle from './CreateProductsStyle'
import Button from '../../../components/Button'
import { useNavigate } from 'react-router-dom'
import api, { customFuncsApi } from '../../../api'
import { get } from 'lodash'
import time from '../../../helpers/time'
import {
	ErrorModal,
	SuccessModal,
	WarningModal,
	CreateUser,
} from '../../../components/Modal'
import { useSelector } from 'react-redux'
import Layout from '../../../components/Layout'
import ConfirmModal from '../../../components/ComfirmModal'
import customMainApi from '../../../api/index'
import AddImage from '../../../components/AddNewImage/index'
import _ from 'lodash'
import CreateIcloudModal from '../../../components/Modal/CreateIcloud'
import { AutoComplete, Select, Input, Table, Tooltip, message } from 'antd'
import { formatNumberWithIntl } from '../../../utils/formatNumber'
import { BG_COLOR } from '../../../constants/colors'

const CreateProducts = () => {
	const { getMe, roleAccess } = useSelector((state) => state.main)

	const isFilterByWhs = roleAccess?.U_AddSalesFilterWhs === 'Y'
	const whs = getMe?.U_Warehouse
	const isShowOwner = roleAccess?.U_AddSalesShowOwner === 'Y'

	const navigate = useNavigate()

	const errorRef = useRef()
	const infoNotEndedRef = useRef()
	const successModalRef = useRef()
	const succesCreateUserRef = useRef()
	const createUserRef = useRef()
	const createIcloud = useRef()

	const initialDocLine = {
		itemCode: '',
		itemName: '',
		item: '',
		quantity: 1,
		serialNumbers: [],
		serialNumbersData: [],
		serialNumbersText: '',
		color: '',
		condition: '',
		memory: '',
		currentPrice: 0,
		icloudCode: '',
		icloudName: '',
		shopfrontPrice: 0,
		percent: '',
		unitPrice: 0,
	}

	const [icloudData, setIcloudData] = useState([])
	const [loadingIcloud, setLoadingIcloud] = useState(false)

	const [customerData, setCustomerData] = useState([])
	const [productNameData, setProductNameData] = useState([])
	const [seriaNumberData, setSeriaNumberData] = useState([])

	const [customer, setCustomer] = useState('')
	const [customerSearch, setCustomerSearch] = useState('')
	const [userCardCode, setUserCardCode] = useState('')
	const [viewData, setViewData] = useState({})

	const [isMainLoading, setIsMainLoading] = useState(false)
	const [createUserLoading, setCreateUserLoading] = useState(false)
	const [comment, setComment] = useState('')
	const [owner, setOwner] = useState({})
	const [showModal, setShowModal] = useState(false)
	const [confirmationMessage, setConfirmationMessage] = useState('')
	const [salesPerson, setSalesPerson] = useState([])
	const [slp, setSlp] = useState('')
	const [userFields, setUserFields] = useState([])
	const [warehouses, setWarehouses] = useState([])
	const [amount, setAmount] = useState(0)
	const [docLines, setDocLines] = useState([initialDocLine])
	const [bpLoading, setBpLoading] = useState(false)
	const [itemLoading, setItemLoading] = useState(false)
	const [sysNumberLoading, setSysNumberLoading] = useState(false)
	// const [icloudName, setIcloudName] = useState('')

	const [imageList, setImageList] = useState([
		{ file: null, path: '', imgLoading: false },
	])

	useEffect(() => {
		getSalesPersons()
		userFieldsFn()
		getWarehouses()
	}, [])

	useEffect(() => {
		searchUser(customerSearch)
	}, [customerSearch])

	const debouncedSearchIcloud = _.debounce((value) => searchIcloud(value), 1000)
	const handleBusinessPartner = _.debounce((setValue, value) => {
		setValue(value)
	}, 1000)

	const debouncedSearchItem = _.debounce((value) => searchProduct(value), 500)

	const searchIcloud = (a = '') => {
		setLoadingIcloud(true)

		api
			.get(
				`Security1?$select=Code,Name,U_Whichtelephone,U_Password,U_Status,U_TypeAccount&$orderby=Code desc&$filter=U_Status eq 'bosh' and (contains(Name, '${a}') or contains(Code, '${a}'))`,
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setIcloudData(resData)
			})
			.catch((err) => {
				if (JSON.parse(JSON.stringify(err, null, 2)).status === 401) {
					navigate('/login')
				} else {
					errorRef.current?.open(
						get(
							JSON.parse(err.response.data),
							'error.message',
							'Не удалось получить данные, попробуйте еще раз.',
						),
					)
				}
			})
			.finally(() => {
				setLoadingIcloud(false)
			})
	}

	const getSalesPersons = () => {
		api
			.get(`SalesPersons?$filter=Active eq 'tYES'`, {
				headers: {
					Prefer: 'odata.maxpagesize=1000000',
				},
			})
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setSalesPerson(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить серийный номер. Повторите попытку.',
					),
				)
			})
	}

	const getWarehouses = () => {
		customMainApi
			.get('Warehouses?$select=WarehouseCode,WarehouseName')
			.then((res) => {
				console.log(res.data)
				setWarehouses(JSON.parse(res.data).value)
			})
			.catch((err) => {
				if (err)
					errorRef.current?.open(
						JSON.stringify(err.response.data?.details?.message),
					)
			})
	}

	const handleOpenModal = () => {
		console.log(docLines)
		// const isSellable = docLines.every((el) => {
		// 	const realPrice = Number(el.currentPrice)
		// 	const sellPrice = Number(el.shopfrontPrice)
		// 	return sellPrice >= Number((realPrice * 0.98).toFixed(2))
		// })

		// if (!isSellable) {
		// 	errorRef.current?.open(
		// 		get('', 'error.message', 'Ошибка: введена неверная сумма продажи!'),
		// 	)
		// 	return
		// }

		const lines = docLines.flatMap((v) => {
			return [
				{
					name: '------------------------------------------',
					// value: '--------------',
				},
				{
					name: 'Товар:',
					value: v.itemName,
				},
				{
					name: 'Серийный номер:',
					value: v.serialNumbersData.map((item) => item.IntrSerial).join(', '),
				},
				{
					name: 'Цена:',
					value: v.shopfrontPrice,
				},
			]
		})

		setConfirmationMessage([
			{
				name: 'Клиент:',
				value: customer,
			},
			...(!isShowOwner ? [] : [{ name: 'Кому принадлежит:', value: owner }]),
			{
				name: 'Менеджер продаж',
				value:
					salesPerson.find((v) => v.SalesEmployeeCode === Number(slp))
						?.SalesEmployeeName || 'Менеджер не найден',
			},

			{
				name: 'Comment:',
				value: comment,
			},

			...lines,
		])
		setShowModal(true)
	}

	const searchUser = (a = '') => {
		api
			.get(
				`BusinessPartners?$select=CardCode,CardName,Address,U_Telephone,U_Gender,U_PS,BPAddresses&$filter=CardType eq 'cCustomer' and Frozen eq 'tNO' and (contains(CardName, '${a}') or contains(U_PS, '${a}') or contains(CardCode, '${a}') or contains(U_Telephone, '${a}'))`,
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				setCustomerData(resData)
			})
			.catch((err) => {
				if (JSON.parse(JSON.stringify(err, null, 2)).status === 401) {
					navigate('/login')
				} else {
					errorRef.current?.open(
						get(
							JSON.parse(err.response.data),
							'error.message',
							'Не удалось получить данные, попробуйте еще раз.',
						),
					)
				}
			})
	}

	const searchProduct = (a = '') => {
		setItemLoading(true)
		customFuncsApi
			.get(
				`/xsSql/getItemsByWarehouse?${isFilterByWhs ? `whsCode='${whs}'&` : ``}ItemName=${a}&isOnHand=true`,
			)
			.then((res) => {
				const resData = get(res.data, 'value', [])
				setProductNameData(resData)
			})
			.catch((err) => {
				if (JSON.parse(JSON.stringify(err, null, 2)).status === 401) {
					navigate('/login')
				} else {
					errorRef.current?.open(
						get(
							JSON.parse(err.response.data),
							'error.message',
							'Не удалось получить данные, попробуйте еще раз.',
						),
					)
				}
			})
			.finally(() => {
				setItemLoading(false)
			})
	}

	const getSameSerialNumnber = (num) => {
		customFuncsApi
			.get(
				`/xsSql/getItemSerialsByWhsCode?ItemCode='${num}'${isFilterByWhs ? `&WhsCode='${whs}'` : ``}`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=1000000',
					},
				},
			)
			.then((res) => {
				const resData = get(res.data, 'value', [])
				setSeriaNumberData(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить серийный номер. Повторите попытку.',
					),
				)
			})
	}

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OINV'",
					$select: 'Name,ValidValuesMD,TableName',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const getOtherInformationsfromSerialNumber = (num) => {
		customFuncsApi
			.get(
				`/xsSql/getItemsByWarehouse?${isFilterByWhs ? `whsCode='${whs}'&` : ``}IntrSerial='${num}'&isOnHand=true`,
			)
			.then((res) => {
				const resData = get(res.data, 'value', [])
				setProductNameData(resData)
			})
			.catch((err) => {
				if (JSON.parse(JSON.stringify(err, null, 2)).status === 401) {
					navigate('/login')
				} else {
					errorRef.current?.open(
						get(
							JSON.parse(err.response.data),
							'error.message',
							'Не удалось получить данные, попробуйте еще раз.',
						),
					)
				}
			})
	}

	const createUserF = (
		consumer,
		passport,
		male,
		address,
		phone,
		cardCode,
		workplace,
		typeCardCode,
	) => {
		setCreateUserLoading(true)
		api
			.post(`BusinessPartners`, {
				[typeCardCode ? 'CardCode' : 'Series']: cardCode,
				CardName: consumer,
				CardType: 'cCustomer',
				U_Telephone: phone.length ? phone : undefined,
				U_Gender: male,
				U_PS: passport.length ? passport : undefined,
				Currency: '##',
				U_workplace: workplace.length ? workplace : undefined,
				U_address: address.length ? address : undefined,
			})
			.then(() => {
				// try {
				// 	logsUrl.post('apis', {
				// 		company_name: COMPANY_NAME,
				// 		method: 'post',
				// 		path: '/BusinessPartners',
				// 		description: "naqt to'lovlarda business partner yaratish",
				// 		username: `${getMe.FirstName} ${getMe.LastName}, EmployeeID: ${getMe.EmployeeID}`,
				// 		body: JSON.stringify({
				// 			CardCode: cardCode,
				// 			CardName: consumer,
				// 			CardType: 'cCustomer',
				// 			U_Telephone: phone.length ? phone : undefined,
				// 			U_Gender: male,
				// 			U_PS: passport.length ? passport : undefined,
				// 			Currency: '##',
				// 			U_workplace: workplace.length ? workplace : undefined,
				// 			U_address: address.length ? address : undefined,
				// 		}),
				// 	})
				// } catch (err) {
				// 	errorRef.current?.open(
				// 		'Bu jarayon logs tarixiga saqlanmadi. Iltimos bu haqida bizga habar bering!',
				// 	)
				// }
				createUserRef.current?.close()
				succesCreateUserRef.current?.open('Пользователь успешно создан')
			})
			.catch((err) => {
				errorRef.current?.open(
					get(
						JSON.parse(err.response.data),
						'error.message',
						'Не удалось получить данные, попробуйте еще раз.',
					),
				)
			})
			.finally(() => {
				setCreateUserLoading(false)
			})
	}

	const checkU_WHSCode = () => {
		// if (get(getMe, 'Department2.Name', '') !== 'Boshqaruv') {
		if (!whs) {
			alert('Foydalanuvchiga ombor biriktirilmagan')
		} else {
			createOrder()
		}
		// } else {
		// createOrder()
		// }
	}

	const createOrder = () => {
		const photoId = imageList
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')
		const nowDays = new Date()

		const documentLines = docLines.map((v) => {
			return {
				ItemCode: v.itemCode,
				SerialNumbers: v?.serialNumbersData?.map((item) => {
					return {
						InternalSerialNumber: item.IntrSerial,
						SystemSerialNumber: item.SysNumber,
					}
				}),
				Quantity: v.quantity,
				UnitPrice: v.shopfrontPrice,
				WarehouseCode: whs,
			}
		})

		setIsMainLoading(true)
		let body = {
			CardCode: userCardCode,
			DocDate: time.to(nowDays, 'YYYY-MM-DD'),
			// DocDate: '2025-06-02',
			// U_Icloud: icloudName,
			U_Owner: isShowOwner ? owner : undefined,
			U_PhotoID: photoId,
			U_TypeInvoice: 'Naqd',
			Comments: comment,
			SalesPersonCode: Number(slp),
			DocumentLines: documentLines,
			U_EmployeeId: getMe.EmployeeID,
			// DocTotal: amount,
		}

		console.log('body', body)

		api
			.post(`Invoices`, body)
			.then((res) => {
				// try {
				// 	logsUrl.post('apis', {
				// 		company_name: COMPANY_NAME,
				// 		method: 'post',
				// 		path: API_ROOT_PROD + '/Invoices',
				// 		description: "naqt to'lovlarda invoice yaratish",
				// 		username: `${getMe.FirstName} ${getMe.LastName}, EmployeeID: ${getMe.EmployeeID}`,
				// 		body: JSON.stringify(body),
				// 	})
				// } catch (err) {
				// 	errorRef.current?.open(
				// 		'Bu jarayon logs tarixiga saqlanmadi. Iltimos bu haqida bizga habar bering!',
				// 	)
				// }
				const resData = JSON.parse(res.data)
				setViewData({
					...resData,
					CardName: get(resData, 'CardName', ''),
					DocEntry: get(resData, 'DocEntry', 0),
					CardCode: get(resData, 'CardCode', 0),
					DocumentLines: {
						ItemDescription: get(resData, 'ItemDescription', ''),
					},
				})
				// closeIcloud(icloudCode)
				successModalRef.current?.open('Заказ успешно создан')
			})
			.catch((err) => {
				setIsMainLoading(false)
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	const customersOptions = customerData.map((v) => ({
		label: (
			<Tooltip title={`${v.CardName}, ${v.CardCode}`}>
				<span className="text-wrap">{`${v.CardName}, ${v.CardCode}`}</span>
			</Tooltip>
		),
		value: v.CardCode,
		cardName: v.CardName,
		cardCode: v.CardCode,
	}))

	const salesPersonOptions = salesPerson.map((v) => ({
		label: (
			<Tooltip title={`${v.SalesEmployeeName}`}>
				<span className="text-wrap">{`${v.SalesEmployeeName}`}</span>
			</Tooltip>
		),
		value: v.SalesEmployeeCode,
		salesEmployeeName: v.SalesEmployeeName,
		salesEmployeeCode: v.SalesEmployeeCode,
	}))

	const ownerOptions = userFields
		?.find((item) => item.Name === 'Owner')
		?.ValidValuesMD.map((value) => ({
			label: (
				<Tooltip title={`${value.Description}`}>
					<span className="text-wrap">{`${value.Description}`}</span>
				</Tooltip>
			),
			value: value.Value,
			name: value.Description,
			code: value.Value,
		}))

	const itemsOptions = productNameData.map((v) => ({
		label: (
			<Tooltip title={`${v.ItemName}, ${v.ItemCode}`}>
				<span className="text-wrap">{`${v.ItemName}, ${v.ItemCode}`}</span>
			</Tooltip>
		),
		key: `${v.ItemName}, ${v.ItemCode} , ${v.WhsCode}`,
		value: v.ItemCode,
		itemName: v.ItemName,
		itemCode: v.ItemCode,
		color: v.U_Color,
		condition: v.U_Condition,
		memory: v.U_Memory,
		whsCode: v.WhsCode,
		currentPrice: v.CurrentPrice,
		shopfrontPrice: v.U_ShopfrontPrice,
	}))

	const serialNumberOptions = seriaNumberData.map((v, i) => ({
		label: `${i + 1})${v.IntrSerial}`,
		value: v.IntrSerial,
		currentPrice: v.CostTotal,
		shopfrontPrice: v.U_ShopfrontPrice,
		data: v,
	}))

	const icloudOptions = icloudData.map((v, i) => ({
		label: `${v.Name}`,
		value: v.Code,
	}))

	const columns = [
		{
			title: 'Товар',
			dataIndex: 'item',
			key: 'item',
			render: (val, record, index) => (
				<AutoComplete
					className="w-full"
					value={val}
					options={itemsOptions}
					loading={itemLoading}
					onChange={(val, label) => {
						debouncedSearchItem(val)
						let docLinesData = [...docLines]
						docLinesData[index].item = val
						if (val === '') {
							docLinesData[index].itemCode = ''
							docLinesData[index].itemName = ''
							docLinesData[index].color = ''
							docLinesData[index].condition = ''
							docLinesData[index].memory = ''
							docLinesData[index].currentPrice = ''
							docLinesData[index].serialNumbersText = ''
							docLinesData[index].serialNumbers = []
						}
						setDocLines(docLinesData)
					}}
					onSelect={(val, label) => {
						console.log(val, label)
						let docLinesData = [...docLines]
						docLinesData[index].itemCode = val
						docLinesData[index].itemName = label.itemName
						docLinesData[index].color = label.color
						docLinesData[index].condition = label.condition
						docLinesData[index].memory = label.memory
						docLinesData[index].item = `${label.itemName}, ${label.itemCode}`
						docLinesData[index].serialNumbers = []
						setDocLines(docLinesData)
						getSameSerialNumnber(val)
					}}
				/>
			),
			width: 300,
		},
		{
			title: 'Поиск по серийным номерам',
			dataIndex: 'serialNumbersText',
			key: 'serialNumbersText',
			render: (val, record, index) => (
				<Input
					value={val}
					className="w-full"
					loading={sysNumberLoading}
					onChange={(e) => {
						let docLinesData = [...docLines]
						docLinesData[index].serialNumbersText = e.target.value
						setDocLines(docLinesData)
						getOtherInformationsfromSerialNumber(e.target.value)
					}}
				/>
			),

			width: 200,
		},
		{
			title: 'Количество',
			dataIndex: 'quantity',
			key: 'quantity',
			render: (val, record, index) => (
				<Input
					value={val}
					className="w-full"
					onChange={(e) => {
						let docLinesData = [...docLines]
						docLinesData[index].quantity = e.target.value
						const price = docLinesData.reduce(
							(a, b) => a + +b.shopfrontPrice * +b.quantity,
							0,
						)
						setAmount(price)
						setDocLines(docLinesData)
					}}
				/>
			),

			width: 200,
		},
		{
			title: 'Cерийный номер',
			dataIndex: 'serialNumbers',
			key: 'serialNumbers',
			render: (val, record, index) => (
				<div>
					<Select
						value={val}
						options={serialNumberOptions}
						className="w-52"
						loading={sysNumberLoading}
						mode="multiple"
						onChange={(val, label) => {
							console.log(val, label)
							let docLinesData = [...docLines]
							if (val === '') {
								docLinesData[index].serialNumbers = []
								docLinesData[index].currentPrice = ''
								docLinesData[index].shopfrontPrice = ''
							}
							if (val?.length <= record.quantity) {
								docLinesData[index].serialNumbers = val
								docLinesData[index].serialNumbersData = label?.map(
									(v) => v.data,
								)
							} else {
								message.error(
									'Серийных номеров не может быть больше количества товара',
								)
							}
							docLinesData[index].currentPrice = label[0]?.currentPrice
							docLinesData[index].shopfrontPrice = label[0]?.shopfrontPrice || 0
							const price = docLinesData.reduce(
								(a, b) => a + +b.shopfrontPrice * +b.quantity,
								0,
							)
							setAmount(price)
							setDocLines(docLinesData)
							console.log(docLinesData)
						}}
						disabled={!record.itemCode || !userCardCode}
					/>
					{record.quantity != record.serialNumbers.length &&
						record.serialNumbers.length > 0 && (
							<span className="text-red-500">
								Недостаточно серийных номеров
							</span>
						)}
				</div>
			),

			width: 200,
		},
		{
			title: 'Цвет',
			dataIndex: 'color',
			key: 'color',
			width: 150,
		},
		{
			title: 'Состояние',
			dataIndex: 'condition',
			key: 'condition',
			width: 150,
		},
		{
			title: 'Текущая цена',
			dataIndex: 'currentPrice',
			key: 'currentPrice',
			render: (val, record, index) => <span>{formatNumberWithIntl(val)}</span>,
		},
		{
			title: 'Цена продажи',
			dataIndex: 'shopfrontPrice',
			key: 'shopfrontPrice',
			width: 150,
			render: (val, record, index) => (
				<Input
					className="w-full"
					type="number"
					onWheel={(e) => e.target.blur()}
					value={val}
					disabled={
						!record.itemCode ||
						!userCardCode ||
						record.serialNumbers.length === 0
					}
					onChange={(e) => {
						let docLinesData = [...docLines]
						docLinesData[index].shopfrontPrice = e.target.value
						setDocLines(docLinesData)
						const price = docLinesData.reduce(
							(a, b) => a + +b.shopfrontPrice * +b.quantity,
							0,
						)
						setAmount(price)
					}}
				/>
			),
		},

		{
			title: 'Actions',
			key: 'action',
			render: (text, record, index) => (
				<div className="flex gap-2">
					<button
						className="bg-[#0A4D68] text-white w-8 h-8 rounded-md"
						onClick={() => {
							let docLinesData = [...docLines]
							docLinesData.push(initialDocLine)
							setDocLines(docLinesData)
						}}
					>
						+
					</button>
					{docLines?.length > 1 && (
						<button
							className="bg-red-500 text-white w-8 h-8 rounded-md"
							onClick={() => {
								let docLinesData = [...docLines]
								docLinesData.splice(index, 1)
								const price = docLinesData.reduce(
									(a, b) => a + +b.shopfrontPrice * +b.quantity,
									0,
								)
								setAmount(price)
								setDocLines(docLinesData)
							}}
						>
							-
						</button>
					)}
				</div>
			),
		},
	]

	return (
		<Layout>
			<CreateProductsStyle
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					{/* {get(getMe, 'Department2.Name', '') === 'Boshqaruv' ? (
						<div className="mb-5">
							<div className={'flex items-center gap-1 w-full '}>
								<select
									id={'from-warehouse'}
									className={`bg-[#FAFBFC] border-[1px] ${
										!toWarehouse ? 'border-red-500' : 'border-[#DFE2E8]'
									} rounded-md p-3 text-[14px] text-[#1E1F1F] w-[315px]`}
									onChange={(e) => setToWarehouse(e.target.value)}
									value={toWarehouse}
									required
								>
									<option value={''} disabled>
										Выберите склад
									</option>
									{warehouses.map((v, i) => (
										<option key={i} value={v.WarehouseCode}>
											{v.WarehouseName}
										</option>
									))}
								</select>
								<ClipLoader size={15} loading={warehouseLoading} />
							</div>
							{!toWarehouse && (
								<p className="text-red-500 text-sm">
									Пожалуйста, выберите склад. Это обязательное поле.
								</p>
							)}
						</div>
					) : null} */}
					<div className="flex flex-col gap-5 w-full overflow-x-auto">
						<div className="flex items-start gap-5 flex-wrap">
							<div className="flex flex-col gap-2 items-start">
								<p className="font-semibold text-sm">Клиент</p>
								<div className="flex gap-2 items-center w-full">
									<AutoComplete
										className="h-8 w-[300px]"
										options={customersOptions}
										value={customer}
										loading={bpLoading}
										onChange={(v) => {
											setCustomer(v)
											handleBusinessPartner(setCustomerSearch, v)
										}}
										onSelect={(v, label) => {
											setUserCardCode(v)
											setCustomer(`${label.cardName}, ${label.cardCode}`)
										}}
									/>
									<button
										className="bg-[#0A4D68] text-white w-10 h-8 rounded-md"
										onClick={() => createUserRef.current?.open()}
									>
										+
									</button>
								</div>
							</div>

							{isShowOwner && (
								<div className="flex flex-col gap-2 items-start">
									<p className="font-semibold text-sm">Кому принадлежит</p>
									<Select
										onChange={(v) => setOwner(v)}
										value={owner}
										options={ownerOptions}
										className="h-8 w-[200px]"
										placeholder="Кому принадлежит"
										showSearch
									/>
								</div>
							)}
							<div className="flex flex-col gap-2 items-start">
								<p className="font-semibold text-sm">Менеджер продаж</p>
								<Select
									onChange={(v) => setSlp(v)}
									value={slp}
									options={salesPersonOptions}
									className="h-8 w-[200px]"
									placeholder="Менеджер продаж"
									showSearch
								/>
								{!slp && (
									<p className="text-red-500 text-sm w-[200px]">
										Пожалуйста, выберите Менеджер. Это обязательное поле.
									</p>
								)}
							</div>
							{/* <div className="flex flex-col items-start gap-2">
								<p className="font-semibold text-sm">Аккаунт защиты</p>
								<div className="flex gap-2 items-center">
									<AutoComplete
										value={icloudName}
										options={icloudOptions}
										className="w-[200px] h-8"
										loading={loadingIcloud}
										onChange={(val, label) => {
											setIcloudName(val)
											debouncedSearchIcloud(val)
										}}
										onSelect={(val, label) => {
											setIcloudName(label.label)
										}}
									/>
									<div className="w-8">
										<button
											className="bg-[#0A4D68] text-white w-8 h-8 rounded-md"
											onClick={() => createIcloud.current?.open()}
										>
											+
										</button>
									</div>
								</div>
								{!icloudName && (
									<p className="text-red-500 text-sm w-[200px]">
										Обязательное поле.
									</p>
								)}
							</div> */}
						</div>
						<div className="mt-5 overflow-x-auto">
							<Table
								dataSource={docLines}
								columns={columns}
								pagination={false}
								scroll={{ x: 'max-content' }}
								bordered
								className=" border-[1px] border-gray-500 "
							/>
							<div className="mt-10 flex justify-between">
								<div className="flex flex-col gap-2 items-start">
									<div className="flex flex-col gap-2 items-start mt-4">
										<p className="font-semibold text-sm">Общая сумма</p>
										<Input
											value={formatNumberWithIntl(amount)}
											disabled={true}
										/>
									</div>
								</div>
								<div className="flex flex-col gap-2 items-start ">
									<p className="font-semibold text-sm">Комментарии</p>
									<Input.TextArea
										value={comment}
										onChange={(e) => setComment(e.target.value)}
										className="w-[300px]"
										placeholder="Комментарий"
										rows={3}
									/>
								</div>
							</div>
							<AddImage imageList={imageList} setImageList={setImageList} />
						</div>
					</div>
					<div className="flex gap-3 mt-8 justify-end w-full">
						<Button
							btnStyle={{ backgroundColor: 'red' }}
							onClick={() => navigate('/sales')}
						>
							Назад
						</Button>
						<Button
							onClick={() => {
								if (!Object.keys(owner).length && isShowOwner) {
									alert('Пожалуйста, выберите Кому принадлежит')
									return
								}
								handleOpenModal()
							}}
							isLoading={isMainLoading}
							disabled={
								!slp ||
								!userCardCode ||
								docLines.some((v) => !v.itemCode) ||
								docLines.some((v) => v.serialNumbersData?.length === 0) ||
								docLines.some((v) => v.serialNumbersData?.length != v.quantity)
							}
						>
							Создать
						</Button>
					</div>
				</div>
			</CreateProductsStyle>

			<>
				<CreateUser
					isLoading={createUserLoading}
					getRef={(r) => (createUserRef.current = r)}
					onConfirm={(
						consumer,
						passport,
						male,
						address,
						phone,
						cardCode,
						workplace,
						typeCardCode,
					) =>
						createUserF(
							consumer,
							passport,
							male,
							address,
							phone,
							cardCode,
							workplace,
							typeCardCode,
						)
					}
				/>
				<ErrorModal
					getRef={(r) => (errorRef.current = r)}
					onConfirm={() => {
						setIsMainLoading(false)
					}}
				/>
				<SuccessModal
					getRef={(r) => {
						succesCreateUserRef.current = r
					}}
				/>
				<SuccessModal
					getRef={(r) => {
						successModalRef.current = r
					}}
					onConfirm={() => navigate('/viewItem', { state: viewData })}
				/>

				<WarningModal
					getRef={(ref) => {
						infoNotEndedRef.current = ref
					}}
				/>
				<CreateIcloudModal
					getRef={(r) => (createIcloud.current = r)}
					onConfirm={() => {
						succesCreateUserRef.current?.open('Аккаунт защиты успешно создан')
					}}
				/>
				<ConfirmModal
					show={showModal}
					data={confirmationMessage}
					onConfirm={() => {
						setShowModal(false)
						checkU_WHSCode()
					}}
					onCancel={() => {
						setShowModal(false)
					}}
				/>
			</>
		</Layout>
	)
}

export default CreateProducts
